import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/less/common.less";

import ViewUI from 'view-design';
// import './utils/iviewUsed'

import 'view-design/dist/styles/iview.css';
// 复制
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
    // 拖拽排序
import VueDND from 'awe-dnd'
Vue.use(VueDND)

Vue.config.productionTip = false

Vue.use(router);
Vue.use(ViewUI);


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')